<template>
  <g transform="matrix(1,0,0,1,0,0)">
    <path
      d="M10.082,9.5A4.47,4.47,0,0,0,6.75,8H5.25a4.5,4.5,0,0,0,0,9h1.5a4.474,4.474,0,0,0,3.332-1.5"
      class="fill-none"
      :style="[strokeStyle]"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
    <path
      d="M13.918,9.5A4.469,4.469,0,0,1,17.25,8h1.5a4.5,4.5,0,1,1,0,9h-1.5a4.472,4.472,0,0,1-3.332-1.5"
      class="fill-none"
      :style="[strokeStyle]"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
    <path
      d="M6.75 12.499L17.25 12.499"
      stroke-width="1.5"
      :style="[strokeStyle]"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
  </g>
</template>

<script>
const IconMixin = require("@/mixins/IconMixin").default;

export default {
  name: "IconLink",
  mixins: [IconMixin],
  data() {
    return {};
  },
  props: {},
  computed: {}
};
</script>
